import { useEffect, useState } from 'react';
import Footer from './footer';
import Header from './header';
import { onServer } from '../api';

export default function Site({ content }) {
	const [scrollPosition, setScrollPosition] = useState(0);

	useEffect(() => {
		if (onServer()) return;
		const handleScroll = () => {
			const scrollContainer = document.getElementById('site-container');
			const scrollPosition = scrollContainer.scrollTop;
			setScrollPosition(scrollPosition);
		};

		const scrollContainer = document.getElementById('site-container');
		if (!scrollContainer) return;
		scrollContainer.addEventListener('scroll', handleScroll);

		// Cleanup the event listener on component unmount
		return () => {
			scrollContainer.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<div id="site-container" className="site-shell">
			<Header
				fixed
				navHeight={
					96 - scrollPosition / 5
					//Math.max((scrollPosition - containerOuterHeight) / 5, 0)
				}
			/>

			<main className="site-main">
				<div className="element legal-content">{content}</div>
			</main>
			<Footer />
		</div>
	);
}
